import { render, staticRenderFns } from "./display-field-date-range.vue?vue&type=template&id=4830b131&scoped=true&"
import script from "./display-field-date-range.ts?vue&type=script&lang=ts&"
export * from "./display-field-date-range.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-date-range.scss?vue&type=style&index=0&id=4830b131&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4830b131",
  null
  
)

export default component.exports